import React, {useEffect, useState} from "react";
import "./AboutUs.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import {getAssetPath} from "../../services/helpers";
import {useNavigate} from "react-router-dom";

import {getLocalStorageData, storeData} from "../../services/localStorageService";

const AboutUs = () => {

    return (
        <>
            <main className="main_wrapper">
       <div className="inn-ban">
            <div className="container">
                <div className="row">
                    <h1>About Us</h1>
                    <p>Helping individuals discover lifelong companionship with confidence and care.</p>
                </div>
            </div>
        </div>
        <section className="h-about-us">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img
                className="about-img"
                src={`${process.env.PUBLIC_URL}/assets/imgs/intro_img.png`}
              ></img>
            </div>
            <div
              className="col-md-6 about_right-content"
            >
              <div className="section-heading">
                <h1 className="headingtxt">
                  Welcome to <br></br>
                  <span>Vikas Mandal Mulund</span>
                </h1>
              </div>
              <div className="txt-content">
                <p>
                  Back in 1970, young and social minded migrants from Jalgaon and Buldhana district to Mulund, Mumbai came together and established Vikas Mandal, Mulund on 9th October, 1970 to propogate socio-cultural and educational activities. The mandal was registered under Mumbai Public Charitable Trust Act 1950 with registration number E4412. Registered under Public Health Department, Brihanmumbai Municipal Corporation, T-Ward/Reg.No.4, Dated 6th July 2016.
                </p>
                <hr></hr>
                <p>Vikas Mandal Mulund is a public charitable trust registered under Mumbai Public Trust Act, 1950 vide Registration No. B.O.M. E-4412, ESTD.1970. with registered address - 101, Jai Laxminarayan Society, Lokmanya Tilak Road, Mulund (East), Mumbai 400081.Registered under Public Health Department, Brihanmumbai Municipal Corporation, T-Ward/Reg.No.4, Dated 6th July 2016</p>
              </div>
            </div>
          </div>
        </div>
      </section>

       <section className="ab-cont">
        <div className="container">
          <div className="row">
            <ul>
              <li>
                <div className="ab-cont-po">
                  <i className="fa fa-heart" aria-hidden="true"></i>
                  <div>
                    <h4>2K</h4>
                    <span>Couples pared</span>
                  </div>
                </div>
              </li>
              <li>
                <div className="ab-cont-po">
                  <i className="fa fa-users" aria-hidden="true"></i>
                  <div>
                    <h4>4000+</h4>
                    <span>Registerents</span>
                  </div>
                </div>
              </li>
              <li>
                <div className="ab-cont-po">
                  <i className="fa fa-male" aria-hidden="true"></i>
                  <div>
                    <h4>1600+</h4>
                    <span>Mens</span>
                  </div>
                </div>
              </li>
              <li>
                <div className="ab-cont-po">
                  <i className="fa fa-female" aria-hidden="true"></i>
                  <div>
                    <h4>2000+</h4>
                    <span>Womens</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="h-about-us pb-0">
        <div className="container">
          <div className="row">
            
            <div
              className="col-md-6 about_right-content"
            >
              <div className="section-heading">
                <h1 className="headingtxt">
                  Digital Matrimony <br></br>
                  <span>Services Since 2015</span>
                </h1>
              </div>
              <div className="txt-content">
                <p>Since the year 2015, Vikas Mandal, Mulund is providing the facility of registering profile information online. This is an completely online process only meant for prospective brides and grooms to facilitate lawful marriages between persons of Leva Patidar community. Leva Patidar candidates desirous of using the services offered will be required to register their information online only, and become a member of Vikas Mandal Mulund's Vadhu Var Suchi.
The main objective was to awaken and train the community in Mulund and surrounding regions, especially for members of the mandal, well wishers in the field of education, sports, culture, literature and social service and to carry out various activities in the above fields and motivate them on mutual co-operation.</p>
              </div>
            </div>


            <div className="col-md-6">
              <img
                className="about-img"
                src={`${process.env.PUBLIC_URL}/assets/imgs/intro_img.png`}
              ></img>
            </div>
          </div>
        </div>
      </section>

      <section className="h-about-us">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img
                className="about-img"
                src={`${process.env.PUBLIC_URL}/assets/imgs/intro_img.png`}
              ></img>
            </div>
            <div
              className="col-md-6 about_right-content"
            >
              <div className="section-heading">
                <h1 className="headingtxt">
                  <span>Our Activities & Initiatives</span>
                </h1>
              </div>
              <div className="txt-content">
                <ul className="activity-list">
    <li>Dasara Snehasammelan</li>
    <li>Annual Get-Together</li>
    <li>Prize Distribution to Meritorious Students</li>
    <li>Felicitation of Members for Professional Excellence</li>
    <li>Organising Competitions</li>
    <li>Organising Vadhu Var Melawa</li>
    <li>Community Welfare Activities</li>
    <li>Activities by Mahila Samiti</li>
    <li>Running Library Activities</li>
    <li>Helping People Affected by Natural Calamities</li>
    <li>Running Educational Activities</li>
    <li>Conducting Vocational & Professional Trainings</li>
    <li>Providing Community Health Services</li>
    <li>Yoga Training</li>
  </ul>
              </div>
            </div>


            
          </div>
        </div>
      </section>
      </main>
        </>
    );
};

export default AboutUs;
